import {
    Routes,
    Route,
    Navigate,
    Outlet
  } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Nuevo from "../components/Nuevo";
import SignIn from "../components/SignIn";
import SignUp from "../components/SignUp";
import Afiliados from "../components/Afiliados";
import { IState } from '../interface';
import { Password } from '../components/Password';
  
export const AppRoutes = () => {
    const  { idUser: user } = useSelector((state: IState) => state.user.user);

    return (
        <Routes>
          <Route path="/" element={user ? <Navigate to="/afiliados" /> : <Outlet />} >
            <Route path="" element={<Nuevo />} />
            <Route path="/registro" element={<SignUp />} />
            <Route path="inicio" element={<SignIn />} />
            <Route path="/password" element={<Password />} />
          </Route>

          <Route path="" element={user ? <Outlet /> : <Navigate to="/inicio" />} >
            <Route path="/" element={<Nuevo />} />
            <Route path="/registro" element={<SignUp />} />
            <Route path="/afiliados" element={<Afiliados />} />
            <Route path="/inicio" element={<SignIn />} />
          </Route>
        </Routes>
    )
}